"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link.js");
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _common = require("@nerdwallet/marketplace/selectors/common");
var _constants = require("@nerdwallet/marketplace/constants");
var _reactApplyNow = require("@nerdwallet/react-apply-now");
var _applyNowWrapper = _interopRequireDefault(require("./apply-now-wrapper"));
var _constants2 = require("./constants");
var _mappings = _interopRequireDefault(require("./mappings"));
var _excluded = ["CtaComponent"],
  _excluded2 = ["botSuspected", "disableAnnotation", "hideInstitutionFromAnnotation", "shouldLogImpression", "trkTaxonomy", "type"];
var PRODUCT_TYPES_REQUIRING_DISPLAY_PAGE = [_constants.PRODUCT_TYPES.BANKING];
var BaseMarketplaceApplyNow = function BaseMarketplaceApplyNow(_ref) {
  var _ref$CtaComponent = _ref.CtaComponent,
    CtaComponent = _ref$CtaComponent === void 0 ? _applyNowWrapper.default : _ref$CtaComponent,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return CtaComponent ? /*#__PURE__*/_react.default.createElement(CtaComponent, props) : null;
};
var MarketplaceApplyNow = function MarketplaceApplyNow(_ref2) {
  var _ref2$botSuspected = _ref2.botSuspected,
    botSuspected = _ref2$botSuspected === void 0 ? false : _ref2$botSuspected,
    _ref2$disableAnnotati = _ref2.disableAnnotation,
    disableAnnotation = _ref2$disableAnnotati === void 0 ? false : _ref2$disableAnnotati,
    _ref2$hideInstitution = _ref2.hideInstitutionFromAnnotation,
    hideInstitutionFromAnnotation = _ref2$hideInstitution === void 0 ? false : _ref2$hideInstitution,
    _ref2$shouldLogImpres = _ref2.shouldLogImpression,
    shouldLogImpression = _ref2$shouldLogImpres === void 0 ? true : _ref2$shouldLogImpres,
    _ref2$trkTaxonomy = _ref2.trkTaxonomy,
    trkTaxonomy = _ref2$trkTaxonomy === void 0 ? (0, _get2.default)(global, 'window.nwPageTaxonomy') : _ref2$trkTaxonomy,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? _constants2.LINK_TYPES.BUTTON : _ref2$type,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var shouldIgnoreTrk = (0, _reactApplyNow.useIgnoreTrkContext)();
  var mappedProps = (0, _mappings.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    botSuspected: botSuspected,
    disableAnnotation: disableAnnotation,
    hideInstitutionFromAnnotation: hideInstitutionFromAnnotation,
    shouldLogImpression: shouldLogImpression,
    trkTaxonomy: trkTaxonomy,
    type: type,
    shouldIgnoreTrk: shouldIgnoreTrk
  }));
  if (mappedProps.impressionId) mappedProps.productImpressionId = mappedProps.impressionId;
  var children = mappedProps.children;
  return mappedProps.link ? /*#__PURE__*/_react.default.createElement(BaseMarketplaceApplyNow, mappedProps) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
};

// Note that all props are passed directly to the CtaComponent that is rendered. Check the
// CtaComponent's file for props specific to that component. Most productTypes will use
// ApplyNowWrapper. Non-monetizing entities may use review-link.
MarketplaceApplyNow.propTypes = {
  /** Metadata for use in related analytics events
   *  @deprecated This metadata was for Delphi analytics, which is no longer in use.
   */
  analyticsMetadata: _propTypes.default.shape({
    pageNumber: _propTypes.default.number,
    elementPosition: _propTypes.default.number,
    sectionName: _propTypes.default.string,
    sectionPosition: _propTypes.default.number
  }),
  /** Is the user suspected to be a bot? Defaults to `false`.
   *  This is required for firing a `shopping_finished` event and can be filled if the consumer apps is
   *  able to detect this (using CloudFlare headers or otherwise).
   */
  botSuspected: _propTypes.default.bool,
  /** Disable annotation text */
  disableAnnotation: _propTypes.default.bool,
  /** Hide institution name from annotation text (only banking for now) */
  hideInstitutionFromAnnotation: _propTypes.default.bool,
  /** The displayPage name for the page this component will be rendered on. This is required
      for `banking`. Must be one of:
      https://github.com/NerdWallet/react-components/blob/master/components/banking-product-cta/src/banking-product-cta.jsx#L13 */
  displayPage: function displayPage(props, propName, componentName) {
    var productType = (0, _common.getProductType)(props.marketplaceEntity);
    if ((0, _includes2.default)(PRODUCT_TYPES_REQUIRING_DISPLAY_PAGE, productType) && typeof props[propName] !== 'string') {
      return new Error("Prop ".concat(propName, " is required when \"productType\" is set to \"banking\" for ").concat(componentName, "."));
    }
    return null;
  },
  /** Href for the review link (used if the offer is non-monetizing) */
  reviewLink: _propTypes.default.string,
  /** Whether or not an impression event should be logged.
   Defaults to true and should only be set to false for testing/storybook purposes. */
  shouldLogImpression: _propTypes.default.bool,
  /** Marketplace entity to render. */
  marketplaceEntity: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  /** The type of component. If not provided, this will try to be derived from `type`. */
  trkElement: _propTypes.default.string,
  /** The page type to use for tracking */
  trkPageType: _propTypes.default.string,
  /** Where on the page the component is */
  trkSectionCategory: _propTypes.default.string,
  /** The page taxonomy to use for tracking. Defaults to the nwPageTaxonomy stored on the window. */
  trkTaxonomy: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  /** The link type (button vs. link). Must be one of:
      https://github.com/NerdWallet/react-components/blob/master/components/marketplace-apply-now/src/constants.js#L2
      Defaults to `BUTTON`. */
  type: _propTypes.default.oneOf([_constants2.LINK_TYPES.BUTTON, _constants2.LINK_TYPES.LINK])
};
var _default = MarketplaceApplyNow;
exports.default = _default;